export function getErrors(data, requiredFields) {
  const errors = {}
  requiredFields.forEach(requiredField => {
    const value = data[requiredField]
    if (!value || !value.length) {
      errors[requiredField] = true
    }
  })
  return errors
}

export function moveCaratToEnd(e) {
  const el = e.target
  el.setSelectionRange(el.value.length, el.value.length)
}
